'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    Loading = require('components/Commons/Loading/Loading'),
    NavigationUtils = require('utils/NavigationUtils'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    InventoryStore = require('stores/InventoryStore'),
    get = require('lodash/object').get,
    {Navigation} = require('react-router'),
    ga = require('react-ga');

let VendorAddressAdmin = React.createClass({displayName: "VendorAddressAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedVendor: null,
            companyName: NavigationUtils.getQueryParam('companyName')
        };
    },

    componentDidMount() {
        this.fetchVendor();
        ga.pageview('/vendor-address-admin');
    },

    fetchVendor() {
        const self = this;
        const vendorId = NavigationUtils.getPathParam('vendors');
        InventoryStore.fetchVendorAddresses(vendorId, function (addresses) {
            self.setState({
                addresses
            });
        });
    },

    _goToContacts() {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const companyName = NavigationUtils.getQueryParam('companyName');
        this.transitionTo('/vendors/:vendorId/contacts', {vendorId}, {companyName});
    },

    _goToSetItems() {
        const vendorId = NavigationUtils.getPathParam('vendors');
        const companyName = NavigationUtils.getQueryParam('companyName');
        this.transitionTo('/vendors/:vendorId/items', {vendorId}, {companyName});
    },

    _backToVendor() {
        this.transitionTo('/vendors');
    },

    _onDeleteAddress(addressId, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_admin_confirm_delete_address'), () => {
            InventoryStore.deleteVendorAddress(NavigationUtils.getPathParam('vendors'), addressId, onSuccess, onFailure);
        });
    },

    _onChangeAddress(address, onSuccess, onFailure) {
        InventoryStore.changeVendorAddress(NavigationUtils.getPathParam('vendors'), address, onSuccess, onFailure);
    },

    _onAddAddress(address, onSuccess, onFailure) {
        InventoryStore.addVendorAddress(NavigationUtils.getPathParam('vendors'), address, onSuccess, onFailure);
    },

    _onRowSelection(item) {
        this.setState({
            selectedItem: item
        });
    },

    _onCancel() {
        this.setState({
            selectedItem: null
        });
    },

    _getBreadcrumbLinks() {
        return [
            {link: 'vendors', displayName: t('dashboard_sidebar_suppliers')},
            {displayName: get(this.state, 'companyName')}
        ];
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    render() {
        let {addresses, selectedItem} = this.state;
        if (!addresses) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('vendor_admin_change_address_success_message'),
                changeFailureMessage: t('vendor_admin_change_address_failure_message'),
                deleteSuccessMessage: t('vendor_admin_delete_address_success_message'),
                addSuccessMessage: t('vendor_admin_add_address_success_message'),
                addFailureMessage: t('vendor_admin_add_address_failure_message')
            };
            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                        label: t('back'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick:  this._backToVendor}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('back'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._backToVendor}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                        label: t('vendor_admin_address_set_contacts'), 
                        icon: "subdirectory_arrow_left", 
                        type: "icon", 
                        onClick:  this._goToContacts}
                    )
                },
                {
                    type: 'NEW',
                    permission: 'NEW',
                    el: React.createElement(FormGroupButton, {
                      label: t('vendor_admin_set_items'), 
                      icon: "subdirectory_arrow_left", 
                      type: "icon", 
                      onClick:  this._goToSetItems}
                    )
                }
            ];

            let contextHolder = this.getContextHolderInstance();

            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    isRelaxedText: true, 
                    operationsHolder: contextHolder, 
                    displayAttribute: "address", 
                    readerAttribute: "address", 
                    writerAttribute: "address", 
                    isRequired: true, 
                    name: t('address'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_address'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    isRelaxedText: true, 
                    operationsHolder: contextHolder, 
                    displayAttribute: "postCode", 
                    readerAttribute: "postCode", 
                    writerAttribute: "postCode", 
                    isRequired: true, 
                    name: t('post_code'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_post_code'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    isRelaxedText: true, 
                    operationsHolder: contextHolder, 
                    displayAttribute: "city", 
                    readerAttribute: "city", 
                    writerAttribute: "city", 
                    isRequired: true, 
                    name: t('city'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_city'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    isRelaxedText: true, 
                    operationsHolder: contextHolder, 
                    displayAttribute: "state", 
                    readerAttribute: "state", 
                    writerAttribute: "state", 
                    isRequired: true, 
                    name: t('state'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_state'), 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    displayAttribute: "country", 
                    readerAttribute: "country", 
                    writerAttribute: "country", 
                    isRequired: true, 
                    name: t('country'), 
                    value: selectedItem, 
                    label: t('vendor_admin_label_country'), 
                    onEnter: this._onEnterPress}
                )
            ];

            return (
                React.createElement("div", {className: "brewhouse-view"}, 
                    React.createElement(AdminScaffolding, {
                        moduleName: "ADMIN_VENDOR_ADDRESS", 
                        title: t('vendor_admin_label_supplier_addresses'), 
                        messages: messages, 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems:  this.fetchVendor, 
                        headerFields: formFieldsEl, 
                        onAdd:  this._onAddAddress, 
                        onChange:  this._onChangeAddress, 
                        onCancel:  this._onCancel, 
                        onDelete:  this._onDeleteAddress, 
                        additionalButtons: additionalButtons, 
                        breadcrumb: this._getBreadcrumbLinks(), 
                        addEnterKeyDown: this._addEnterKeyDown
                    }, 

                        React.createElement(AdminScaffoldingTable, {
                            onRowSelection:  this._onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['name'], 
                            filteredColumns: ['address', 'postCode', 'city', 'state', 'country'], 
                            columnNames: [
                                t('vendor_admin_label_address'),
                                t('vendor_admin_label_post_code'),
                                t('vendor_admin_label_city'),
                                t('vendor_admin_label_state'),
                                t('vendor_admin_label_country')], 
                            displayAttributes: ['address', 'postCode', 'city', 'state', 'country']
                        }, 
                            addresses 
                        )
                    )
                )
            );
        }
    }
});

module.exports = VendorAddressAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorAdmin/VendorAddressAdmin.js
 **/